import { dataProps, 
        productionPieceRateListProps, 
        overtimeListProps } from './properties'

export const setEmployeeMasterList = (state, payload) => {
    state.list = payload.response
    state.nav.total = payload.total
    state.nav.page_number = payload.page_number
    if(!state.nav.had_results) {
    state.nav.had_results = payload.total>0
    }
}    

export const setEmployeeStatement = (state, payload) => {
    state.statement.list = payload
}

export const setEmployeeMasterData = (state, payload) => {
    state.props = payload.response
    
    if(state.props.overtime_list.length === 0) {
        state.props.overtime_list = []

    } else if(payload.copy) {
        state.props.overtime_list.forEach(element => {
            element.id = 0
        })
    }

    let key = 0
    state.props.overtime_list.forEach(element => {
        element.key = key
        key ++
    })

    if(state.props.production_piece_rate_list.length === 0) {
        state.props.production_piece_rate_list = [JSON.parse(JSON.stringify(productionPieceRateListProps))]
    } else if(payload.copy) {
        state.props.production_piece_rate_list.forEach(element => {
            element.id = 0
        })
    }

    key = 0
    state.props.production_piece_rate_list.forEach(element => {
        element.key = key
        key ++
    })
} 

export const addNewEmployeeMasterOvertimeListRow = state => {

    let key = 0
    state.props.overtime_list.push(JSON.parse(JSON.stringify(overtimeListProps)))

    state.props.overtime_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('overtime_id_'+(key-1)).focus()
    }, 300);

}

export const removeEmployeeMasterOvertimeListRow = (state, payload) => {

    let key = 0

    state.props.deleted_overtime_list.push(state.props.overtime_list[payload])

    state.props.overtime_list.splice(payload, 1)

    if(state.props.overtime_list.length === 0) {
        state.props.overtime_list = [JSON.parse(JSON.stringify(overtimeListProps))]
    }

    state.props.overtime_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const addNewEmployeeMasterProductionPieceRateListRow = state => {

    let key = 0
    state.props.production_piece_rate_list.push(JSON.parse(JSON.stringify(productionPieceRateListProps)))

    state.props.production_piece_rate_list.forEach(element => {
        element.key = key
        key ++
    })

    setTimeout(() => {
        document.getElementById('category_id_'+(key-1)).focus()
    }, 300);

}

export const removeEmployeeMasterProductionPieceRateListRow = (state, payload) => {

    let key = 0

    state.props.deleted_production_piece_rate_list.push(state.props.production_piece_rate_list[payload])

    state.props.production_piece_rate_list.splice(payload, 1)

    if(state.props.production_piece_rate_list.length === 0) {
        state.props.production_piece_rate_list = [JSON.parse(JSON.stringify(productionPieceRateListProps))]
    }

    state.props.production_piece_rate_list.forEach(element => {
        element.key = key
        key ++
    })

}

export const setEmployeeMasterUserPassword = (state, payload) => {
    state.props.user_password = payload
}

export const setEmployeeProductionStageList = (state, payload) => {
    state.allocated_production_stage = payload
}

export const resetEmployeeMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/employee/mutations.js